jQuery( document ).ready( function( $ ) {


/* ------ MOBILE Menu ----- */

$('.hamburger').click(function(){

    if ( $('.hamburger').hasClass('open') ) {
        //$('body').removeClass('freeze');
        $('.hamburger').removeClass('open');
        $('.hamburger').html('<i class="fal fa-bars"></i>');
        $('.mobile-menu').slideUp();
    } else {
        //$('body').addClass('freeze');
        $('.hamburger').addClass('open');
        $('.hamburger').html('<i class="fal fa-times"></i>');
        $('.mobile-menu').slideDown();
    }

    e.preventDefault();
});

  $('.mobile-menu .sub-links').prev('a').addClass('has-children');

$('a.has-children').click(function(e){

    if ( $(this).hasClass('open') ) {
      $(this).removeClass('open');
      $(this).next('.sub-links').slideUp();

    } else {
		 $(this).addClass('open');
       $(this).next('.sub-links').slideDown();
    }

    e.preventDefault();
});

/* ------ Mega Menu ----- */

  $('section.header .left li:nth-child(1) a').addClass('toggle-mega');
  $('section.header .left li:nth-child(2) a').addClass('toggle-mega');

  $('section.header .left li:nth-child(1) a').attr('data-name', 'mega-women');
  $('section.header .left li:nth-child(2) a').attr('data-name', 'mega-men');



$('.toggle-mega').hover(function(){

    if ( $(this).hasClass('open') ) {

    } else {
        var whichMenu = $(this).data('name');

        $('.mega-menu-vex').hide();
        $('.toggle-mega').removeClass('open');

        $(this).addClass('open');
        $('.mega-menu-vex#' + whichMenu).slideDown();
    }

});

$('section.header .menu a').hover(function(){
    if ( $(this).hasClass('toggle-mega') ) {

    } else {
        $('.mega-menu-vex').slideUp();
        $('.toggle-mega').removeClass('open');
    }
});


$(document).mouseover(function(e)
{
    var container = $('section.header');

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('.mega-menu-vex').slideUp();
        $('.toggle-mega').removeClass('open');
    }
});



    $('.toggle-search a').click(function(e){

        $('.search-box').toggleClass('open');
        e.preventDefault();
    });

    $(document).mouseup(function(e)
    {
        var container = $(".toggle-search");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0)
        {
            $('.search-box').removeClass('open');
        }
    });



/* ------ Video Slideshow ----- */

  $('.video-slider').slick({
    dots: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 3,
    appendArrows: $('.celeb-videos .arrows'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


/* ------ Best Selling Slideshow ----- */

  $('.best_selling .product-slider').slick({
    dots: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 3,
    appendArrows: $('.best_selling .arrows'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false,
          arrows: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        dots: true,
        arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        dots: true,
        arrows: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


/* ------ Collections Slideshow ----- */

$('.latex_collections .collection-slider').slick({
    dots: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 2,
    slidesToScroll: 2,
    appendArrows: $('.latex_collections .arrows'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
});

/* ------ Quote Slideshow ----- */

$('.quote-slider').slick({
    dots: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
});

/* ------ Celeb Slideshow ----- */

$('.celeb-quotes').slick({
    dots: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
});


/* ------ Fade in Elements on Scroll ----- */

$(window).scroll( function(){

    $('.fadein').each( function(i){

        var bottom_of_element = $(this).offset().top + $(this).outerHeight();
        var bottom_of_window = $(window).scrollTop() + $(window).height();

        if( bottom_of_window > bottom_of_element ){
            $(this).animate({'opacity':'1'},1000);
        }
    });

    $('.parallax').each( function(i){

        var bottom_of_element = $(this).offset().top + $(this).outerHeight();
        var bottom_of_window = $(window).scrollTop() + $(window).height();

        if( bottom_of_window > bottom_of_element ){
            //$(this).animate({'opacity':'1'},1000);
            //$(this).animate({'margin-top':'-40px'},1000);



            $(".magic img").each(function(index) {

                if ( $(this).hasClass('top') ) {
                    $(this).delay(600*index).animate({'opacity':'1', 'margin-top':'-40px'},1000);
                } else {
                    $(this).delay(600*index).animate({'opacity':'1', 'margin-bottom':'60px'},1000);
                }
            });

        }


    });

});



if ($('.fadein').is(':within-viewport')) {
      $(this).animate({'opacity':'1'},1000);
}



});


/* ============================================================
   VEX — Show line-item Length (and other properties) in the
   slide-out mini-cart drawer.
   Background: the mini-cart is rendered by refreshCart() in
   app.js, which used the old Bold "item.properties_formatted"
   field. That field no longer exists (Bold was removed), so the
   length the customer picks was not appearing in the drawer.
   This reads the real properties from /cart.js and injects them
   into each drawer line. The full /cart page already renders
   properties correctly, so this only touches the drawer.
   ============================================================ */
jQuery( document ).ready( function( $ ) {

  var container = document.querySelector('.js-cart_items');
  if ( !container ) { return; }

  function vexInject( cart ) {
    if ( !cart || !cart.items ) { return; }

    $('.js-cart_items .mini-cart__item').each(function(){
      var $item  = $(this);
      var lineId = parseInt( $item.attr('data-line-id'), 10 );
      if ( !lineId ) { return; }

      var cartItem = cart.items[ lineId - 1 ];
      if ( !cartItem ) { return; }

      // Remove any broken line ("undefined" / empty) left by the old code.
      $item.find('.line-item').each(function(){
        var t = $.trim( $(this).text() );
        if ( t === '' || t === 'undefined' ) { $(this).remove(); }
      });

      // Build the list of real, customer-facing properties.
      var props = [];
      if ( cartItem.properties ) {
        for ( var k in cartItem.properties ) {
          if ( cartItem.properties.hasOwnProperty(k) &&
               k.charAt(0) !== '_' &&
               cartItem.properties[k] ) {
            props.push( k + ': ' + cartItem.properties[k] );
          }
        }
      }
      if ( !props.length ) { return; }

      // If we've already injected exactly this, do nothing (prevents loops).
      var existing = $item.find('.vex-line-item').map(function(){
        return $.trim( $(this).text() );
      }).get();
      if ( existing.join('|') === props.join('|') ) { return; }

      $item.find('.vex-line-item').remove();
      var html = '';
      for ( var i = 0; i < props.length; i++ ) {
        html += '<div class="line-item vex-line-item">' + props[i] + '</div>';
      }

      var $title = $item.find('.item_title').first();
      if ( $title.length ) {
        $title.after( html );
      } else {
        $item.find('.mini-cart__item--content').first().prepend( html );
      }
    });
  }

  function vexRefresh() {
    $.getJSON('/cart.js', vexInject);
  }

  // refreshCart() does $('.js-cart_items').html(...) which replaces the
  // direct children of the container. Watch only direct childList changes
  // (not subtree) so our own injections inside each <li> don't re-trigger us.
  if ( window.MutationObserver ) {
    var obs = new MutationObserver(function(){ vexRefresh(); });
    obs.observe( container, { childList: true } );
  }

  // Initial pass, in case the drawer is already populated on load.
  vexRefresh();

});


/* ============================================================
   VEX — Default any REQUIRED "choose an option" line-item
   property picker to its first real value, so it can never be
   submitted blank. Add-to-cart posts FormData, which bypasses the
   browser's HTML5 "required" rule, so an empty picker (e.g. the
   hood's Hair Color "-- Choose a hair color --") would otherwise
   drop silently and never reach the cart or the order. This
   mirrors how the Length picker defaults to "Full Length".
   Never blocks add-to-cart; it only fills in a default value.
   ============================================================ */
(function(){
  function vexFirstRealIndex(sel){
    for (var i = 0; i < sel.options.length; i++){
      if (sel.options[i].value !== '') { return i; }
    }
    return -1;
  }
  function vexDefaultPickers(root){
    var scope = (root && root.querySelectorAll) ? root : document;
    var sels = scope.querySelectorAll('select[required][name^="properties["]:not([data-vex-force])');
    for (var i = 0; i < sels.length; i++){
      var sel = sels[i];
      var cur = (sel.selectedIndex > -1 && sel.options[sel.selectedIndex]) ? sel.options[sel.selectedIndex].value : '';
      if (sel.value === '' || cur === ''){
        var idx = vexFirstRealIndex(sel);
        if (idx > -1){ sel.selectedIndex = idx; }
      }
    }
  }

  // On load: pre-select a real value so the shopper sees it chosen.
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ vexDefaultPickers(document); });
  } else {
    vexDefaultPickers(document);
  }

  // Safety net: just before add-to-cart (capture phase, before the
  // theme's own click handler builds FormData), make sure no required
  // property picker in that form is still blank. Covers forms loaded
  // dynamically, such as quick-shop popups.
  document.addEventListener('click', function(e){
    var btn = (e.target && e.target.closest) ? e.target.closest('.ajax-submit, button[name="add"], input[name="add"]') : null;
    if (!btn){ return; }
    var form = btn.closest('form');
    if (form){ vexDefaultPickers(form); }
  }, true);
})();


/* ============================================================
   VEX — Reliable add-to-cart that always keeps the line-item
   options. The Bold Upsell app (upsells.boldapps.net) hijacks the
   Add-to-Cart button click and re-adds the item through its own
   flow, which DROPS the custom line-item properties (Shoe Size,
   Cup Size, Bra Size, Crown, Trim Color, Inseam, etc.).
   This claims the click first (document capture phase, which runs
   before Bold's button-level listener), enforces the required
   option pickers, adds the item cleanly with ALL its properties,
   then sends the shopper to the cart.
   ============================================================ */
(function(){
  function vexEmptyRequired(form){
    return Array.prototype.slice.call(form.querySelectorAll('select[required][name^="properties["]'))
      .filter(function(s){ return s.value === ''; });
  }
  document.addEventListener('click', function(e){
    var btn = (e.target && e.target.closest)
      ? e.target.closest('.ajax-submit, button[name="add"], input[name="add"], .action_button.add_to_cart')
      : null;
    if(!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if(!form) return;
    // Only take over when this product actually has custom option pickers
    // (line-item properties) that Bold would otherwise drop. Plain products
    // keep the theme's normal add-to-cart behavior.
    if(!form.querySelector('[name^="properties["]')) return;
    // We own this click — stop Bold Upsell and the theme's own handler.
    e.preventDefault();
    e.stopImmediatePropagation();
    var missing = vexEmptyRequired(form);
    if(missing.length){
      missing.forEach(function(s){
        s.style.borderColor = '#b00020';
        // reveal the picker snippet's own "please choose…" message if it has one
        var wrap = (s.closest && s.closest('.vex-converted-opt, #inseam-picker, #trim-color-field, #hair-color-field, #garterclip-picker, .rk-select')) || s.parentNode;
        var err = wrap && wrap.querySelector ? wrap.querySelector('.vex-conv-error, [id$="-error"]') : null;
        if(err){ err.style.display = 'block'; }
      });
      missing[0].scrollIntoView({ behavior:'smooth', block:'center' });
      try { missing[0].focus(); } catch(e){}
      return;
    }
    if(btn.getAttribute('data-vex-busy')) return;
    btn.setAttribute('data-vex-busy','1');
    fetch('/cart/add.js', { method:'POST', body: new FormData(form) })
      .then(function(r){ if(!r.ok){ throw new Error('add failed'); } return r.json(); })
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(){ btn.removeAttribute('data-vex-busy'); alert('Sorry — could not add to cart. Please try again.'); });
  }, true);
})();
